import React from 'react';
import TilesGroup, { Props as TilesGroupProps } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/content/tiles-group';

export interface Props {
  data: TilesGroupProps;
}

const TilesGroupTastic: React.FC<Props> = ({ data }) => {
  return <TilesGroup {...data} />;
};

export default TilesGroupTastic;
